/** @clearscore/redux.market v4.8.6: 2022-12-12 17:54 (assemble v5.5.1) **/
import { GLOBAL, EN_GB, MARKETS, LOCALES, GB, ZA, EN_ZA } from '@clearscore/config.i18n';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';
import getEnv from '@clearscore/helpers.envs';
import * as requestStatuses from '@clearscore/constants.request-statuses';
import { getSessionCookie } from '@clearscore/helpers.cookies';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore/helpers.resolve-request';

/* eslint-disable import/prefer-default-export */
/**
 * Get the app version from querystring if running in webview
 * context (to be passed eventually to segmenter)
 */

var getWebviewAppVersion = function getWebviewAppVersion() {
  var _window$location;
  if (!getEnv('WEBVIEW')) return null;
  return new URLSearchParams((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.search).get('appVersion');
};
var MARKET = 'CS/MARKET';
var MARKET_SET_MARKETS = "".concat(MARKET, "_SET_MARKETS");
var MARKET_SET_LOCALES = "".concat(MARKET, "_SET_LOCALES");
var MARKET_SET_ENVS = "".concat(MARKET, "_SET_ENVS");
var MARKET_SET_ACTIVE_MARKET = "".concat(MARKET, "_SET_ACTIVE_MARKET");
var MARKET_SET_ACTIVE_LOCALE = "".concat(MARKET, "_SET_ACTIVE_LOCALE");
var MARKET_FETCH_CONFIG = "".concat(MARKET, "_FETCH_CONFIG");
var MARKET_FETCH_CONFIG_PENDING = "".concat(MARKET, "_FETCH_CONFIG_PENDING");
var MARKET_FETCH_CONFIG_SUCCESS = "".concat(MARKET_FETCH_CONFIG, "_SUCCESS");
var MARKET_FETCH_CONFIG_ERROR = "".concat(MARKET_FETCH_CONFIG, "_ERROR");
var MARKET_FETCH_STATIC_CONFIG = "".concat(MARKET, "_FETCH_STATIC_CONFIG");
var MARKET_FETCH_STATIC_CONFIG_SUCCESS = "".concat(MARKET_FETCH_STATIC_CONFIG, "_SUCCESS");
var MARKET_FETCH_STATIC_CONFIG_ERROR = "".concat(MARKET_FETCH_STATIC_CONFIG, "_ERROR");
var setMarkets = function setMarkets(markets) {
  return {
    type: MARKET_SET_MARKETS,
    payload: markets
  };
};
var setLocales = function setLocales(locales) {
  return {
    type: MARKET_SET_LOCALES,
    payload: locales
  };
};
var setMarketsEnvs = function setMarketsEnvs(envs) {
  return {
    type: MARKET_SET_ENVS,
    payload: envs
  };
};
var setActiveMarket = function setActiveMarket(market) {
  return createAction(MARKET_SET_ACTIVE_MARKET, {
    market: market
  });
};
var setFetchPending = function setFetchPending() {
  return {
    type: MARKET_FETCH_CONFIG_PENDING
  };
};
var fetchMarketConfig = function fetchMarketConfig(market) {
  var meta = {
    market: market
  };
  var timeout = getEnv('MARKET_REQUEST_TIMEOUT') || 1000;
  var appVersion = getWebviewAppVersion();
  var headers = _objectSpread({
    'x-app-id': getEnv('APP'),
    'x-market-id': market
  }, appVersion && {
    'x-cs-app-version': appVersion
  });
  return createAction(MARKET_FETCH_CONFIG, createRequestPayload('international', '/render-engine-local/v1/config', 'get', null, meta, headers, timeout));
};
var fetchStaticMarketConfig = function fetchStaticMarketConfig(market) {
  return createAction(MARKET_FETCH_STATIC_CONFIG, _objectSpread(_objectSpread({}, createRequestPayload('renderEngine', "".concat(market, ".json?version=").concat(getEnv("".concat(market.toUpperCase(), "_VERSION")) || '1'))), {}, {
    market: market
  }));
};
var setActiveLocale = function setActiveLocale(activeLocale) {
  return createAction(MARKET_SET_ACTIVE_LOCALE, activeLocale);
};
var getCurrentMarketDetails = function getCurrentMarketDetails() {
  var sessionToken = getSessionCookie();
  var marketSessionToken = resolveProp('market', sessionToken);
  var localeSessionToken = resolveProp('locale', sessionToken);
  return {
    marketSessionToken: marketSessionToken,
    localeSessionToken: localeSessionToken
  };
};
var getActiveMarket$1 = function getActiveMarket$1() {
  var _getCurrentMarketDeta = getCurrentMarketDetails(),
    marketSessionToken = _getCurrentMarketDeta.marketSessionToken;
  return marketSessionToken || GLOBAL;
};
var getActiveLocale$1 = function getActiveLocale$1() {
  var _getCurrentMarketDeta2 = getCurrentMarketDetails(),
    marketSessionToken = _getCurrentMarketDeta2.marketSessionToken,
    localeSessionToken = _getCurrentMarketDeta2.localeSessionToken;
  if (localeSessionToken) return localeSessionToken;
  if (marketSessionToken) return "en-".concat(marketSessionToken);
  return EN_GB;
};
var helpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getActiveMarket: getActiveMarket$1,
  getActiveLocale: getActiveLocale$1
});
var initialState = function initialState() {
  return {
    checkStatus: requestStatuses.INITIAL,
    fetchStatus: requestStatuses.INITIAL,
    activeMarket: getActiveMarket$1(),
    activeLocale: getActiveLocale$1(),
    markets: MARKETS,
    locales: LOCALES
  };
};
var domain$1 = function domain$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case MARKET_FETCH_CONFIG:
    case MARKET_FETCH_CONFIG_PENDING: // allow core to be aware of pending updates, without re-fetching the config

    case MARKET_FETCH_STATIC_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.PENDING
      });
    case MARKET_FETCH_CONFIG_SUCCESS:
    case MARKET_FETCH_STATIC_CONFIG_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.SUCCESS
      });
    case MARKET_FETCH_CONFIG_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchStatus: requestStatuses.ERROR
      });
    case MARKET_SET_ACTIVE_MARKET:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMarket: payload && payload.market || initialState().activeMarket,
          activeLocale: payload && "en-".concat(payload.market) || initialState().activeLocale
        });
      }
    case MARKET_SET_ACTIVE_LOCALE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeLocale: payload || initialState().activeLocale
      });
    case MARKET_SET_LOCALES:
      return _objectSpread(_objectSpread({}, state), {}, {
        locales: payload || initialState().locales
      });
    case MARKET_SET_MARKETS:
      return _objectSpread(_objectSpread({}, state), {}, {
        markets: payload || initialState().markets
      });
    default:
      return state;
  }
};

/* eslint-disable import/prefer-default-export */
var domain = domain$1;
var resolveFetchStatus = function resolveFetchStatus(state) {
  return resolveRequest(state, 'market.fetchStatus');
};
var marketGetFetchStatus = createSelector(resolveFetchStatus, function (fetchStatus) {
  return getRequestStatus(fetchStatus);
});
var getCheckStatus = function getCheckStatus(state) {
  return resolveRequest(state, 'market.checkStatus');
};
var marketGetPredicate = createSelector(getCheckStatus, marketGetFetchStatus, function (checkStatus, fetchStatus) {
  return {
    check: getRequestStatus(checkStatus),
    fetch: fetchStatus
  };
});
var marketsSelector = function marketsSelector(state) {
  return resolveProp('market.markets', state);
};
var marketGetMarkets = createSelector(marketsSelector, function (markets) {
  return markets;
});
var activeMarketSelector = function activeMarketSelector(state) {
  return resolveProp('market.activeMarket', state);
};
var marketGetActiveMarket = createSelector(activeMarketSelector, function (activeMarket) {
  return activeMarket;
});
var localesSelector = function localesSelector(state) {
  return resolveProp('market.locales', state);
};
var marketGetLocales = createSelector(localesSelector, function () {
  var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return locales;
});
var legacyMap = {
  uk: 'en-gb',
  za: 'en-za'
};
var localeSelector = function localeSelector() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return state.locale;
};
var getActiveLanguage = function getActiveLanguage() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (locale && locale.languages || []).find(function (copy) {
    return copy.active === true;
  });
};
var getLegacyLanguageCode = createSelector(localeSelector, function (locale) {
  var activeLanguage = getActiveLanguage(locale) || {};
  var activeLocale = activeLanguage.languageCode || activeLanguage.code;
  return legacyMap[activeLocale] || activeLocale || 'en-gb';
});
var activeLocaleSelector = function activeLocaleSelector(state) {
  return resolveProp('market.activeLocale', state);
};
var marketGetActiveLocale = createSelector(activeLocaleSelector, marketGetLocales, getLegacyLanguageCode, function () {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var legacyLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return locales.find(function (item) {
    return item === locale;
  }) || legacyLocale || 'en-gb';
});
var marketGetConfig = createSelector(marketGetActiveMarket, function (activeMarket) {
  return function (marketConfig) {
    return marketConfig[activeMarket] || marketConfig.gb || {};
  };
});
var getResolution$1 = function getResolution$1(state) {
  return resolveProp('market.resolution', state) || 'ip';
};
var marketGetResolution = createSelector(getResolution$1, function (resolution) {
  return resolution;
});
var marketLegacyGetLanguage = createSelector(marketGetActiveLocale, function (locale) {
  return function (copy) {
    return copy[locale] || copy['en-gb'] || copy.uk;
  };
});
var getPredicate = marketGetPredicate;
var getFetchStatus = marketGetFetchStatus;
var getConfig = marketGetConfig;
var getMarkets = marketGetMarkets;
var getActiveMarket = marketGetActiveMarket;
var getLocales = marketGetLocales;
var getActiveLocale = marketGetActiveLocale;
var getResolution = marketGetResolution;
var getLegacyLanguage = marketLegacyGetLanguage;
var actions = {
  setActiveLocale: setActiveLocale,
  setActiveMarket: setActiveMarket,
  setMarkets: setMarkets,
  setLocales: setLocales,
  setMarketsEnvs: setMarketsEnvs,
  fetchMarketConfig: fetchMarketConfig,
  setFetchPending: setFetchPending,
  fetchStaticMarketConfig: fetchStaticMarketConfig
};
var types = {
  MARKET_SET_ACTIVE_LOCALE: MARKET_SET_ACTIVE_LOCALE,
  MARKET_SET_ACTIVE_MARKET: MARKET_SET_ACTIVE_MARKET,
  MARKET_SET_MARKETS: MARKET_SET_MARKETS,
  MARKET_SET_LOCALES: MARKET_SET_LOCALES,
  MARKET_SET_ENVS: MARKET_SET_ENVS,
  MARKET_FETCH_CONFIG: MARKET_FETCH_CONFIG,
  MARKET_FETCH_CONFIG_PENDING: MARKET_FETCH_CONFIG_PENDING,
  MARKET_FETCH_CONFIG_ERROR: MARKET_FETCH_CONFIG_ERROR,
  MARKET_FETCH_CONFIG_SUCCESS: MARKET_FETCH_CONFIG_SUCCESS,
  MARKET_FETCH_STATIC_CONFIG: MARKET_FETCH_STATIC_CONFIG,
  MARKET_FETCH_STATIC_CONFIG_ERROR: MARKET_FETCH_STATIC_CONFIG_ERROR,
  MARKET_FETCH_STATIC_CONFIG_SUCCESS: MARKET_FETCH_STATIC_CONFIG_SUCCESS
};
/* export for backward compatibility, however these should be imported directly from @clearscore/config.i18n */

var constants = {
  GB: GB,
  ZA: ZA,
  GLOBAL: GLOBAL,
  MARKETS: MARKETS,
  EN_GB: EN_GB,
  EN_ZA: EN_ZA,
  LOCALES: LOCALES
};
var reducers = {
  domain: domain
};
var selectors = {
  getFetchStatus: getFetchStatus,
  getPredicate: getPredicate,
  getConfig: getConfig,
  getLocales: getLocales,
  getMarkets: getMarkets,
  getActiveMarket: getActiveMarket,
  getActiveLocale: getActiveLocale,
  getResolution: getResolution,
  getLegacyLanguage: getLegacyLanguage
};
export { actions, constants, helpers, reducers, selectors, types };